import React, { useContext } from 'react'
import { marginSizes, paddingSizes } from '@jarvis.oddle/core/theme/default'
import modalController from 'src/decorators/ModalController'
import { status } from '@jarvis.oddle/core/tools/product'
import Div from '@jarvis.oddle/core/components/Div'
import Flex from '@jarvis.oddle/core/components/Flex'
import Divider from '@jarvis.oddle/core/components/Divider'
import { H4, LinkText } from '@jarvis.oddle/core/components/Typo'
import Label, { labelStates } from '@jarvis.oddle/core/components/Label'
import {
  InlineNotification,
  notificationStates
} from '@jarvis.oddle/core/components/InlineNotification'
import EditableOrderItem from 'src/components/molecules/EditableOrderItem'
import { PromotionalOrderItem } from 'src/components/molecules/OrderItem'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

interface OrderSectionProps {
  clearCartAction: (obj) => void
  orderItems: Oms.V4.OrderItem[]
  promotionalOrderItems: Oms.V4.OrderItem[]
}

const OrderSection = ({
  clearCartAction,
  orderItems,
  promotionalOrderItems
}: OrderSectionProps): JSX.Element => {
  const showClearCartModal = () => {
    modalController.showModal('ClearCartConfirmationModal', {
      onConfirm: () => clearCartAction({})
    })
  }
  const { t } = useContext(TranslationContext)
  return (
    <React.Fragment>
      <Flex
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <H4 bold normalised>
          {t('Item(s) Added')}
        </H4>
        <LinkText onClick={showClearCartModal} heading>
          {t('Clear Items')}
        </LinkText>
      </Flex>
      {orderItems.length > 0 &&
        orderItems.map((item) => {
          const isItemUnavailable = item.status === status.UNAVAILABLE
          const isSubItemsUnavailable = !!(item.subitemChoices || []).find(
            (subitem) => subitem.status === status.UNAVAILABLE
          )
          const isUnavailable = isItemUnavailable || isSubItemsUnavailable

          return (
            <React.Fragment key={item.id}>
              {isUnavailable && (
                <Div
                  margin={marginSizes.small}
                  marginLeft={marginSizes.none}
                  width='100%'
                >
                  <InlineNotification
                    lightTheme
                    state={notificationStates.error}
                    text={
                      isSubItemsUnavailable
                        ? t(
                            'This item or one of the options is no longer available. Remove before checkout.'
                          )
                        : t(
                            'This item is no longer available. Remove before checkout.'
                          )
                    }
                  />
                </Div>
              )}
              <EditableOrderItem
                key={item.id}
                item={item}
              />
              <Divider />
            </React.Fragment>
          )
        })}
      {promotionalOrderItems.length > 0 && (
        <React.Fragment>
          <Div paddingBottom={paddingSizes.small}>
            <Label
              marginTop={marginSizes.small}
              state={labelStates.draft}
              dynamic
            >
              {t('Promotional Items')}
            </Label>
            {promotionalOrderItems.map((item) => (
              <PromotionalOrderItem item={item} />
            ))}
          </Div>
          <Divider />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default OrderSection
